import {
  Badge, Box, Button, CardHeader, IconButton, Paper, Switch,
  Tab, Tabs, Tooltip, Typography,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import React, { useState, useEffect, useCallback } from "react";
import {
  Container, DataGrid, Dialog, InputMask, InputText,
  Loading, Paginate,
} from "src/components";

import {
  Notifications as NotificationsIcon, LocalShipping as LocalShippingIcon,
  Loyalty as LoyaltyIcon, Settings as SettingsIcon, Lock as LockIcon,
  LockOpen as LockOpenIcon, Done as DoneIcon, Close as CloseIcon,
  CheckCircleOutline as CheckCircleOutlineIcon, HighlightOff as HighlightOffIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon,
  HourglassBottom as HourglassBottomIcon, QueryBuilder as QueryBuilderIcon,
  LocalFireDepartment as LocalFireDepartmentIcon, DeliveryDining as DeliveryDiningIcon,
  Air as AirIcon, AssignmentTurnedIn as AssignmentTurnedInIcon, Print as PrintIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";
import ModalConfiguracoes from "./ModalConfiguracoes";
import { useDispatch, useSelector } from "react-redux";
import {
  executaAceite, executaCancelarPedido, executaEmPreparo, executaEnviarEntrega, 
  executaFinalizarEntrega, executaSaiuEntrega, pesquisarPedidos, pesquisarPedidosResumo,
  pesquisarEntregadores,
} from "src/store/actions/pedidos";
import dayjs from "dayjs";
import { saveDeliveryConfig } from "src/store/actions/delivery";
import * as pedidosTypes from "src/store/types/pedidos";
import ModalImprimir from "./ModalImprimir";

import {useInterval} from 'src/helpers'
import useAudio from "../../utils/useAudio";
import theme from "src/theme";

import { ioClosePedido, ioOnPedido } from "src/services/socket";

const cardHeaderTitles = [
  "Aguardando confirmação",
  "Pedidos em preparo",
  "Pronto | Saiu para entrega",
  "Entregues",
  "Cancelados",
];

function Pedidos() {
  const [tab, setTab] = useState(0);
  const [entregador, setEntregador] = useState("");
  const [modal, setModal] = useState("");
  const { 
    pedido, perpage, page, total, pedidos,
    pedidos_qtde_status, entregadores, loading,
  } = useSelector((state) => state.pedidos);
  const { empresa_atual } = useSelector((state) => state.usuario);
  const { delivery_configuracao, delivery_loading } = useSelector((state) => state.delivery);
  const dispatch = useDispatch();
  const [playing, toggle] = useAudio("https://painel.fynd.com.br/pedido.mp3");
  
  useInterval(() => {
    if (!delivery_configuracao.alerta_sonoro) return;

    if (pedidos_qtde_status.aguardando_aceite > 0 && playing === false) {
      toggle();
    } else if (
      pedidos_qtde_status.aguardando_aceite === 0 &&
      playing === true
    ) {
      toggle();
    }
  }, 44000);

  const handleCloseModal = () => {
    setModal("");
  };

  const handleToggleDelivery = () => {
    saveDeliveryConfig({
      ...delivery_configuracao,
      aberto: delivery_configuracao.aberto ? 0 : 1,
    });
  };

  const selectedTab = useCallback(() => {
    return tab === 0
      ? "AGUARDANDO ACEITE"
      : tab === 1
      ? ["PEDIDO ACEITO", "PEDIDO EM PREPARO"]
      : tab === 2
      ? "PEDIDO À CAMINHO"
      : tab === 3
      ? "PEDIDO ENTREGUE"
      : tab === 4
      ? "PEDIDO CANCELADO"
      : "";
  }, [tab]);

  const pesquisar = useCallback(() => {
    dispatch([pesquisarPedidos(selectedTab(tab)), pesquisarPedidosResumo()]);
  }, [dispatch, selectedTab, tab]);

  useEffect(() => {
    pesquisar();
  }, [pesquisar]);

  useEffect(() => {
    if (!delivery_configuracao.alerta_sonoro) return;

    if (pedidos_qtde_status.aguardando_aceite > 0 && playing === false) {
      toggle();
    } else if (
      pedidos_qtde_status.aguardando_aceite === 0 &&
      playing === true
    ) {
      toggle();
    }
    return () => {
      if (playing === true) toggle();
    };
  }, [pedidos_qtde_status]);

  const handleChangePage = (newPage) => {
    dispatch([
      { type: pedidosTypes.SET_PAGE, payload: newPage + 1 },
      /* pesquisarPedidos({
        page: newPage + 1,
        per_page: perpage,
      }), */
      // pesquisarPedidosResumo(),
    ]);
    pesquisar();
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: pedidosTypes.SET_PAGE, payload: 1 },
      {
        type: pedidosTypes.SET_PERPAGE,
        payload: parseInt(event.target.value, 10),
      },
      // pesquisarPedidos(),
      // pesquisarPedidosResumo(),
    ]);
    pesquisar();
  };

  const execAceite = () => {
    executaAceite(pedido.id).then(
      () => {
        pesquisar();
        handleCloseModal();
      },
      (e) => console.log(e)
    );
  };

  const execEmPreparo = () => {
    executaEmPreparo(pedido.id).then(
      () => {
        pesquisar();
        handleCloseModal();
      },
      (e) => console.log(e)
    );
  };

  const execSaindoEntrega = () => {
    executaEnviarEntrega(pedido.id).then(
      () => {
        pesquisar();
        handleCloseModal();
      },
      (e) => console.log(e)
    );
  };

  const execSaiuEntrega = () => {
    executaSaiuEntrega(pedido.id).then(
      () => {
        pesquisar();
        handleCloseModal();
      },
      (e) => console.log(e)
    );
  };

  const execConfirmarEntrega = () => {
    executaFinalizarEntrega(pedido.id).then(
      () => {
        pesquisar();
        handleCloseModal();
      },
      (e) => console.log(e)
    );
  };

  const execCancelar = () => {
    executaCancelarPedido(pedido.id).then(
      () => {
        pesquisar();
        handleCloseModal();
      },
      (e) => console.log(e)
    );
  };

  const carregarPedidos = (data) => {
    dispatch([pesquisarPedidos(data), pesquisarPedidosResumo()]);
  };

  useEffect(() => {
    ioOnPedido(empresa_atual.id, (data) => {
      if (data === "AGUARDANDO ACEITE") carregarPedidos(data);
    });
    return () => {
      ioClosePedido(empresa_atual.id, () => console.log("fechando pedidos."));
    };
  }, [empresa_atual]);

  return (
    <Container className="no-printme" title="Pedidos">
      <ModalImprimir open={modal === "imprimir"} close={handleCloseModal} />
      <Loading loading={delivery_loading} />
      <Dialog
        visible={modal === "cancelar"}
        title="Cancelar Pedido"
        contenttext="Deseja realmente Cancelar o Pedido?"
        buttons={[
          {
            title: "Confirmar",
            // icon: <Icon className="far fa-check-square" />,
            onClick: () => execCancelar(),
            danger: true,
          },
          {
            title: "Cancelar",
            // icon: <Icon className="far fa-window-close" />,
            onClick: handleCloseModal,
            autofocus: true,
          },
        ]}
      />
      <Dialog
        visible={modal === "aceite"}
        title="Aceitar Pedido"
        contenttext="Deseja realmente Aceitar este Pedido?"
        buttons={[
          {
            title: "Aceitar",
            // icon: <Icon className="far fa-check-square" />,
            onClick: () => execAceite(),
            danger: false,
          },
          {
            title: "Cancelar",
            // icon: <Icon className="far fa-window-close" />,
            onClick: handleCloseModal,
            autofocus: true,
          },
        ]}
      />
      <Dialog
        visible={modal === "preparo"}
        title="Inicia Preparação do Pedido"
        contenttext="Deseja realmente Iniciar a Preparação do Pedido?"
        buttons={[
          {
            title: "Preparar",
            // icon: <Icon className="far fa-check-square" />,
            onClick: () => execEmPreparo(),
            danger: false,
          },
          {
            title: "Cancelar",
            // icon: <Icon className="far fa-window-close" />,
            onClick: handleCloseModal,
            autofocus: true,
          },
        ]}
      />
      <Dialog
        visible={modal === "entrega"}
        title="Enviar para Entrega"
        contenttext="Deseja realmente Enviar o pedido para entrega?"
        buttons={[
          {
            title: "Enviar p/ Entrega",
            // icon: <Icon className="far fa-check-square" />,
            onClick: () => execSaindoEntrega(),
            danger: false,
          },
          {
            title: "Cancelar",
            // icon: <Icon className="far fa-window-close" />,
            onClick: handleCloseModal,
            autofocus: true,
          },
        ]}
      />
      <Dialog
        visible={modal === "entregador"}
        title="Saindo para Entrega"
        buttons={[
          {
            title: "Sair p/ Entrega",
            // icon: <Icon className="far fa-check-square" />,
            onClick: () => execSaiuEntrega(),
            danger: false,
          },
          {
            title: "Cancelar",
            // icon: <Icon className="far fa-window-close" />,
            onClick: handleCloseModal,
          },
        ]}
      >
        <Box flex={1} marginBottom="10px">
          <InputText
            select
            label="Entregador"
            value={entregador}
            onChange={(event) => setEntregador(event.target.value)}
            SelectProps={{
              native: true,
            }}
            InputLabelProps={{ shrink: true }}
          >
            {entregadores.map((item) => (
              <option key={item.id} value={item.id}>
                {item.nome}
              </option>
            ))}
          </InputText>
        </Box>
      </Dialog>
      <Dialog
        visible={modal === "entregue"}
        title="Confirmar Entrega"
        contenttext="Deseja realmente confirmar entrega do pedido?"
        buttons={[
          {
            title: "Confirmar",
            // icon: <Icon className="far fa-check-square" />,
            onClick: () => execConfirmarEntrega(),
            danger: false,
          },
          {
            title: "Cancelar",
            // icon: <Icon className="far fa-window-close" />,
            onClick: handleCloseModal,
            autofocus: true,
          },
        ]}
      />
      <Paper>
        <Box display="flex" justifyContent="space-between">
          <CardHeader
            style={{ width: "220px" }}
            title={cardHeaderTitles[tab]}
          />
          <Tabs
            value={tab}
            indicatorColor="secondary"
            textColor="primary"
            onChange={(e, value) => setTab(value)}
            variant="fullWidth"
          >
            <Tooltip title={cardHeaderTitles[0]}>
              <Tab
                icon={
                  <Badge
                    badgeContent={pedidos_qtde_status.aguardando_aceite || null}
                    color={tab === 0 ? "secondary" : "primary"}
                  >
                    <NotificationsIcon
                      color={tab === 0 ? "secondary" : "primary"}
                    />
                  </Badge>
                }
                style={{ maxWidth: 40 }}
              />
            </Tooltip>
            <Tooltip title={cardHeaderTitles[1]}>
              <Tab
                icon={
                  <Badge
                    badgeContent={
                      pedidos_qtde_status.pedido_aceito +
                        pedidos_qtde_status.pedido_em_preparo || null
                    }
                    color={tab === 1 ? "secondary" : "primary"}
                  >
                    <LoyaltyIcon color={tab === 1 ? "secondary" : "primary"} />
                  </Badge>
                }
                style={{ maxWidth: 40 }}
              />
            </Tooltip>
            <Tooltip title={cardHeaderTitles[2]}>
              <Tab
                icon={
                  <Badge
                    badgeContent={pedidos_qtde_status.pedido_a_caminho}
                    color={tab === 2 ? "secondary" : "primary"}
                  >
                    <LocalShippingIcon
                      color={tab === 2 ? "secondary" : "primary"}
                    />
                  </Badge>
                }
                style={{ maxWidth: 40 }}
              />
            </Tooltip>
            <Tooltip title={cardHeaderTitles[3]}>
              <Tab
                icon={
                  <Badge
                    badgeContent={pedidos_qtde_status.pedido_entregue || null}
                    color={tab === 3 ? "secondary" : "primary"}
                  >
                    <DoneIcon color={tab === 3 ? "secondary" : "primary"} />
                  </Badge>
                }
                style={{ maxWidth: 40 }}
              />
            </Tooltip>
            <Tooltip title={cardHeaderTitles[4]}>
              <Tab
                icon={
                  <Badge
                    badgeContent={pedidos_qtde_status.pedido_cancelado || null}
                    color={tab === 4 ? "secondary" : "primary"}
                  >
                    <CloseIcon color={tab === 4 ? "secondary" : "primary"} />
                  </Badge>
                }
                style={{ maxWidth: 40 }}
              />
            </Tooltip>
          </Tabs>

          <Box display="flex" alignItems="center">
            <Button onClick={handleToggleDelivery}>
              {delivery_configuracao.aberto ? (
                  <>
                    <Typography variant="h6" display="block" style={{fontWeight: 'bold', marginRight: "4px", marginTop: 3, color: 'black'}}>
                      ABERTO
                    </Typography>
                    <LockOpenIcon style={{ color: 'black' }} />
                  </>
                ) : (
                  <>
                    <Typography variant="h6" display="block" style={{fontWeight: 'bold', marginRight: "4px", marginTop: 3,  color: 'red'}}>
                      FECHADO
                    </Typography>
                    <LockIcon style={{ color: 'red'}} />
                  </>
                )
              }
            </Button>
            <IconButton onClick={() => setModal("configuracoes")}>
               <SettingsIcon />
            </IconButton>
          </Box>
        </Box>
        <PerfectScrollbar>
          <DataGrid
            isLoading={loading}
            columns={[
              {
                title: "Pedido",
                field: "numero_pedido",
                width: 20,
              },
              {
                title: "Data/Hora",
                cellStyle: {
                  paddingLeft: 0,
                  textAlign: "center",
                },
                headerStyle: { paddingLeft: 0 },
                width: 100,
                render: (rowData) =>
                  dayjs(rowData.created_at).format("DD/MM/YYYY HH:mm:ss"),
              },
              {
                title: "Cliente",
                render: (rowData) => (
                  <Tooltip title={rowData.cliente_nome}>
                    <span>{rowData.cliente_nome}</span>
                  </Tooltip>
                ),
                cellStyle: {
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  paddingLeft: 10,
                  paddingRight: 10,
                  maxWidth: 200,
                },
                headerStyle: {
                  paddingLeft: 10,
                  paddingRight: 10,
                },
                width: "auto",
              },
              {
                title: "R$ Pedido",
                width: 120,
                render: (rowData) => (
                  <InputMask
                    type="cash"
                    displayType="text"
                    value={rowData.valor_total}
                  />
                ),
              },
              {
                title: "R$ Entrega",
                width: 100,
                render: (rowData) => (
                  <InputMask
                    type="cash"
                    displayType="text"
                    value={rowData.valor_entrega}
                  />
                ),
              },
              {
                title: "Cashback",
                width: 150,
                render: (rowData) => {
                  return (
                    <Box display="flex">
                      <Box display="flex">
                        <KeyboardArrowDownIcon
                          style={{ color: theme.palette.secondary.main }}
                        />
                        <InputMask
                          type="cash"
                          displayType="text"
                          value={rowData.cashback_receber}
                          style={{ fontSize: 12, marginTop: 5 }}
                        />
                      </Box>
                      <Box display="flex">
                        <InputMask
                          type="cash"
                          displayType="text"
                          value={rowData.valor_cashback}
                          style={{ fontSize: 12, marginLeft: 10, marginTop: 5 }}
                        />
                        <KeyboardArrowUpIcon
                          style={{ color: theme.palette.success.main }}
                        />
                      </Box>
                    </Box>
                  );
                },
              },
              {
                title: "R$ Total",
                width: 100,
                render: (rowData) => {
                  return (
                    <InputMask
                      type="cash"
                      displayType="text"
                      value={
                        rowData.valor_total +
                        rowData.valor_entrega -
                        rowData.valor_cashback
                      }
                      style={{ fontWeight: "bold" }}
                    />
                  );
                },
              },
              {
                title: "Status",
                cellStyle: { paddingLeft: 10 },
                headerStyle: { paddingLeft: 10 },
                width: 50,
                render: (rowData) => {
                  return rowData.status_pedido === "AGUARDANDO ACEITE" ? (
                    <QueryBuilderIcon
                      style={{ color: theme.palette.warning.main }}
                    />
                  ) : rowData.status_pedido === "PEDIDO ACEITO" ? (
                    <HourglassBottomIcon
                      style={{ color: theme.palette.warning.main }}
                    />
                  ) : rowData.status_pedido === "PEDIDO EM PREPARO" ? (
                    <LocalFireDepartmentIcon style={{ color: "#ff9800" }} />
                  ) : rowData.status_pedido === "PEDIDO À CAMINHO" ? (
                    <AirIcon style={{ color: theme.palette.primary.dark }} />
                  ) : rowData.status_pedido === "PEDIDO ENTREGUE" ? (
                    <CheckCircleOutlineIcon
                      style={{ color: theme.palette.success.main }}
                    />
                  ) : rowData.status_pedido === "PEDIDO CANCELADO" ? (
                    <HighlightOffIcon
                      style={{ color: theme.palette.error.main }}
                    />
                  ) : (
                    rowData.status_pedido
                  );
                },
              },
              {
                title: "Pagamento",
                field: "status_pagamento",
              },
            ]}
            data={pedidos}
            actions={[
              (rowData) => ({
                hidden:
                  rowData.status_pagamento === "AGUARDANDO PAGAMENTO"
                    ? true
                    : rowData.status_pedido === "AGUARDANDO ACEITE"
                    ? false
                    : true,
                icon: () => (
                  <AssignmentTurnedInIcon
                    style={{ color: theme.palette.success.main }}
                  />
                ),
                tooltip: "Aceitar Pedido",
                onClick: () => {
                  dispatch({
                    type: pedidosTypes.SET_LOAD,
                    payload: rowData,
                  });
                  setModal("aceite");
                },
              }),
              (rowData) => ({
                hidden:
                  rowData.status_pedido === "PEDIDO ACEITO" ? false : true,
                icon: () => (
                  <LocalFireDepartmentIcon style={{ color: "#ff9800" }} />
                ),
                tooltip: "Iniciar Preparo",
                onClick: () => {
                  dispatch({
                    type: pedidosTypes.SET_LOAD,
                    payload: rowData,
                  });
                  setModal("preparo");
                },
              }),
              (rowData) => ({
                hidden:
                  rowData.status_pedido === "PEDIDO EM PREPARO" ? false : true,
                icon: () => (
                  <DeliveryDiningIcon
                    style={{ color: theme.palette.info.main }}
                  />
                ),
                tooltip: "Enviar p/ Entrega",
                onClick: () => {
                  dispatch({
                    type: pedidosTypes.SET_LOAD,
                    payload: rowData,
                  });
                  setModal("entrega");
                },
              }),
              (rowData) => ({
                hidden:
                  rowData.status_pedido === "PEDIDO À CAMINHO" ? false : true,
                icon: () => (
                  <AirIcon style={{ color: theme.palette.primary.dark }} />
                ),
                tooltip: "Saiu p/ Entrega",
                onClick: () => {
                  dispatch([
                    pesquisarEntregadores(),
                    {
                      type: pedidosTypes.SET_LOAD,
                      payload: rowData,
                    },
                  ]);
                  setModal("entregador");
                },
              }),
              (rowData) => ({
                hidden:
                  rowData.status_entrega === "SAIU PARA ENTREGA" ? false : true,
                icon: () => (
                  <CheckCircleOutlineIcon
                    style={{ color: theme.palette.success.main }}
                  />
                ),
                tooltip: "Pedido Entregue",
                onClick: () => {
                  dispatch({
                    type: pedidosTypes.SET_LOAD,
                    payload: rowData,
                  });
                  setModal("entregue");
                },
              }),
              (rowData) => ({
                icon: () => (
                  <PrintIcon style={{ color: theme.palette.primary.main }} />
                ),
                tooltip: "Imprimir Pedido",
                onClick: () => {
                  dispatch({
                    type: pedidosTypes.SET_LOAD,
                    payload: rowData,
                  });
                  setModal("imprimir");
                },
              }),
              (rowData) => ({
                hidden:
                  rowData.status_pedido === "PEDIDO CANCELADO" ? true : false,
                icon: () => (
                  <DeleteIcon style={{ color: theme.palette.error.main }} />
                ),
                tooltip: "Cancelar Pedido",
                onClick: () => {
                  dispatch({
                    type: pedidosTypes.SET_LOAD,
                    payload: rowData,
                  });
                  setModal("cancelar");
                },
              }),
            ]}
          />
        </PerfectScrollbar>
        <Paginate
          rowsPerPageOptions={[10, 25, 50]}
          rowsPerPage={perpage}
          count={total}
          page={page - 1}
          onChangePage={(event, newPage) => handleChangePage(newPage)}
          onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
        />
      </Paper>
      <ModalConfiguracoes
        open={modal === "configuracoes"}
        close={handleCloseModal}
      />
    </Container>
  );
}

export default Pedidos;
